import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { MapTooltipLevelType } from './map-tooltip.types';
export interface TooltipDimensions {
  width: number;
  height: number;
}

@Component({
  selector: 'app-map-tooltip',
  template: '',
  styleUrls: ['./map-tooltip.component.scss']
})
export abstract class MapTooltipComponent<T = any> implements AfterViewInit, OnChanges {
  @Input() content: T;
  @Output() dimensionsChange = new EventEmitter<TooltipDimensions>();
  public MapTooltipLevelType = MapTooltipLevelType;

  constructor(protected elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.calculateAndEmitDimensions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.content) {
      // Use setTimeout to ensure the view has been updated
      setTimeout(() => {
        this.calculateAndEmitDimensions();
      });
    }
  }

  protected calculateAndEmitDimensions() {
    const element = this.elementRef.nativeElement;
    if (element) {
      const dimensions: TooltipDimensions = {
        width: element.offsetWidth,
        height: element.offsetHeight
      };
      this.dimensionsChange.emit(dimensions);
    }
  }

  abstract isEmpty(): boolean;
} 